var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnion1 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 0C3.10457 0 4 0.895431 4 2C4 2.277 3.94262 2.5404 3.84082 2.78027L13.2188 12.1582C13.4587 12.0563 13.7228 12 14 12C15.1046 12 16 12.8954 16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 13.7228 12.0563 13.4587 12.1582 13.2188L2.78027 3.84082C2.5404 3.94262 2.277 4 2 4C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnion1);
export { ForwardRef as ReactComponent };